import { zeroPadForOne } from "./ZeroPadForOne";

export const getStringWithZeroPadFromDate = (date: Date | undefined) => {
  if (!date) {
    return "";
  }

  const h = zeroPadForOne(date.getHours());
  const m = zeroPadForOne(date.getMinutes());

  return `${h}:${m}`;
};
